import axios from 'axios'

export const createLabConsole = async (labGroupID, labID) => {
  const response = await axios.get(
    `${import.meta.env.VITE_AWS_API_URL}/ac&8924/list/user/${labGroupID}/${labID}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  )
  return response
}

export const terminateAWSLab = async (labGroupID, labID) => {
  const response = await axios.delete(
    `${import.meta.env.VITE_AWS_API_URL}/ac&8924/list/user/terminate/${labGroupID}/${labID}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
    }
  )
  return response.data
}

export const launchStarshipLab = async (payload) => {
  const response = await axios.post(`${import.meta.env.VITE_GATEWAY_API_URL}/create`, payload, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
    },
    'Content-Type': 'application/json',
  })
  return response
}

export const destroyStarshipLab = async (payload) => {
  const response = await axios.post(`${import.meta.env.VITE_GATEWAY_API_URL}/delete`, payload, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
    },
    'Content-Type': 'application/json',
  })
  return response
}

export const configVSCode = async (payload) => {
  const response = await axios.post(
    `${import.meta.env.VITE_GATEWAY_API_URL}/configure/vscode`,
    payload,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
      'Content-Type': 'application/json',
    }
  )
  return response
}

export const deleteVSCode = async () => {
  const vscodeData = JSON.parse(localStorage.getItem('vscodeData'))
  if (vscodeData) {
    const response = await axios.delete(
      `${import.meta.env.VITE_GATEWAY_API_URL}/configure?type=vscode&hostname=${
        vscodeData.domain
      }&bmId=${vscodeData.bmId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      }
    )
    return response
  } else return
}

export const configureLoadBalancer = async (payload) => {
  const response = await axios.post(
    `${import.meta.env.VITE_GATEWAY_API_URL}/configure/loadbalancer`,
    payload,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
      'Content-Type': 'application/json',
    }
  )
  return { data: response.data, status: response.status }
}

export const deleteSingleLoadBalancer = async (payload) => {
  const response = await axios.delete(
    `${import.meta.env.VITE_GATEWAY_API_URL}/configure?type=loadbalancer&hostname=${
      payload.domain
    }&bmId=${payload.bmId}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
    }
  )
  return { data: response.data, status: response.status }
}

export const configureParrotLab = async (payload) => {
  const response = await axios.post(
    `${import.meta.env.VITE_GATEWAY_API_URL}/configure/parrot`,
    payload,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
      'Content-Type': 'application/json',
    }
  )
  return { data: response.data, status: response.status }
}

export const deleteParrotLab = async () => {
  const parrotData = JSON.parse(localStorage.getItem('parrotData'))
  if (parrotData) {
    const response = await axios.delete(
      `${import.meta.env.VITE_GATEWAY_API_URL}/configure?type=parrot&hostname=${
        parrotData.domain
      }&bmId=${parrotData.bmId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      }
    )
    return { data: response.data, status: response.status }
  } else return
}

export const getLoadBalancerCounter = async (labId) => {
  const response = await axios.get(
    `${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/lab/lb-counter/${labId}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
    }
  )
  return { data: response.data, status: response.status }
}

export const resetLoadBalancerCounter = async (userId, labId) => {
  const payload = {
    lb_counter: 0,
  }
  const response = await axios.put(
    `${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/lab/user/update/${userId}/${labId}`,
    payload,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
    }
  )
  return response
}
